var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInit),expression:"isInit"}],staticClass:"face-box",attrs:{"visible":_vm.visible,"width":"800px"},on:{"close":_vm.close}},[_c('div',{attrs:{"id":"faceContainer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }